export const AMPLIFY_GET_CAMPAIGNS = 'AMPLIFY_GET_CAMPAIGNS';
export const AMPLIFY_GET_DONATIONS = 'AMPLIFY_GET_DONATIONS';
export const AMPLIFY_GET_DONATION_GROUPS = 'AMPLIFY_GET_DONATION_GROUPS';



// WEBPACK FOOTER //
// ./src/constants/amplify.js